import {toAbsoluteUrl} from '../../../../_metronic/helpers'

export const NUKLIE_ICON = toAbsoluteUrl('/media/imgs/nuklie-icon.png')
